import React from 'react';
import useMediaQuery from '../hooks/useMediaQuery';
import { useSlider } from '../hooks/useSlider';
import SliderControls from './slider/SliderControls';
import SliderIndicators from './slider/SliderIndicators';
import SliderCaption from './slider/SliderCaption';
import SlideTransition from './slider/SlideTransition';

const Slider: React.FC = () => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const { 
    currentImage, 
    previousImage,
    nextSlide, 
    previousSlide, 
    totalSlides, 
    currentIndex 
  } = useSlider();

  return (
    <div className="relative w-full overflow-hidden">
      <div 
        className={`relative mx-auto ${!isDesktop && 'px-4'}`}
        style={{ 
          maxWidth: '1759px',
          height: isDesktop ? '607px' : '400px'
        }}
      >
        <div className="relative w-full h-full overflow-hidden">
          <SlideTransition
            isActive={true}
            isPrevious={false}
          >
            <img
              src={currentImage.url}
              alt={currentImage.title}
              className="w-full h-full object-cover"
            />
          </SlideTransition>

          <SlideTransition
            isActive={false}
            isPrevious={true}
          >
            <img
              src={previousImage.url}
              alt={previousImage.title}
              className="w-full h-full object-cover"
            />
          </SlideTransition>

          <SliderCaption
            title={currentImage.title}
            description={currentImage.description}
            isDesktop={isDesktop}
          />
        </div>

        <SliderControls
          onPrevious={previousSlide}
          onNext={nextSlide}
          iconSize={isDesktop ? 24 : 20}
        />

        <SliderIndicators
          total={totalSlides}
          current={currentIndex}
        />
      </div>
    </div>
  );
};

export default Slider;